import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/betHistory.css';
// actions
import {
    openCloseBetBetHistory,
    selectBetHistoryGame,
    selectBetHistoryTab,
    toggleBetHistoryFilterWins
} from '../../actions/betHistoryActions';
// constants
import {VIRTUALS} from '../../../../constants/games';
import {ASSETS_URL} from '../../../../constants/endpoints';
import {ACTIVE_BETS_TAB, SETTLED_BETS_TAB} from '../../constants/identifiers';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FOOTBALL_MODULE,
    RACING_MODULE,
    SETTLED,
    VOIDED
} from '../../../../constants/identifiers';
import {BASE_VALUE} from '../../../../constants/chips';
// helpers
import {getFormattedCurrency, getText} from '../../../../helpers/localization';
import {getModuleFromEventType} from '../../../../helpers/moduleHelpers';
import {formatTimeToHHMM} from '../../../../helpers/helperFunctions';
import {
    getAFMarketNameByCode,
    getBasketballMarketNameByCode,
    getFootballMarketNameByCode,
    getRacingMarketNameByCode
} from '../../helpers/marketHelpers';
import {isLocalStorageAvailable} from '../../../../helpers/systemHelpers';
import {hasEventTypeRacerNumberUI} from '../../modules/racing/helpers/racersHelper';
// components
import CheckCircle from '../components/checkCircle';
import Counter from '../components/counter';

const mapStateToProps = (state, ownProps) => {
    return {
        isBetHistoryOpen: state.vpp.isBetHistoryOpen,
        selectedBetHistoryTab: state.vpp.selectedBetHistoryTab,
        placedBets: state.vpp.placedBets,
        settledBets: state.vpp.settledBets,
        selectedBetHistoryGame: state.vpp.selectedBetHistoryGame,
        filterWinsBetHistory: state.vpp.filterWinsBetHistory,
        isVideoVisible: state.vpp.isVideoVisible,
        isDesktopMode: state.vpp.isDesktopMode
    };
};

class BetHistory extends Component {
    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            selectedBetHistoryTab: storeData.vpp.selectedBetHistoryTab,
            placedBets: storeData.vpp.placedBets,
            settledBets: storeData.vpp.settledBets,
            selectedBetHistoryGame: storeData.vpp.selectedBetHistoryGame,
            filterWinsBetHistory: storeData.vpp.filterWinsBetHistory,
            isVideoVisible: storeData.vpp.isVideoVisible,
            isDesktopMode: storeData.vpp.isDesktopMode
        };
    }

    componentDidMount() {
        this._setScrollArrows();
        document.getElementById('betHistoryGames').addEventListener('scroll', this._setScrollArrows.bind(this));
        window.addEventListener('resize', this._setScrollArrows.bind(this));
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.getElementById('betHistoryGames').removeEventListener('scroll', this._setScrollArrows.bind(this));
        window.removeEventListener('resize', this._setScrollArrows.bind(this));
        document.body.style.overflow = 'auto';
    }

    _setScrollArrows() {
        let tabs = document.getElementById('betHistoryGames');
        let hasScrollLeft = false;
        let hasScrollRight = false;

        if (tabs) {
            if (tabs.scrollLeft > 0) {
                hasScrollLeft = true;
            }
            if (tabs.scrollWidth - tabs.scrollLeft > tabs.clientWidth) {
                hasScrollRight = true;
            }

            this.setState({
                ...this.state,
                hasScrollLeft,
                hasScrollRight
            });
        }
    }

    _scrollGamesLeft(event) {
        event.stopPropagation();
        let gameButtons = document.getElementById('betHistoryGames');
        if (gameButtons) {
            gameButtons.scrollLeft -= 50;
        }
    }

    _scrollGamesRight(event) {
        event.stopPropagation();
        let gameButtons = document.getElementById('betHistoryGames');
        if (gameButtons) {
            gameButtons.scrollLeft += 50;
        }
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();
        this.setState({
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            selectedBetHistoryTab: storeData.vpp.selectedBetHistoryTab,
            placedBets: storeData.vpp.placedBets,
            settledBets: storeData.vpp.settledBets,
            selectedBetHistoryGame: storeData.vpp.selectedBetHistoryGame,
            filterWinsBetHistory: storeData.vpp.filterWinsBetHistory,
            isVideoVisible: storeData.vpp.isVideoVisible,
            isDesktopMode: storeData.vpp.isDesktopMode
        });
    }

    _closeBetHistory(event) {
        event.stopPropagation();
        this.props.store.dispatch(openCloseBetBetHistory());
    }

    _selectBetHistoryTab(event, tabIndex) {
        event.stopPropagation();
        this.props.store.dispatch(selectBetHistoryTab(tabIndex));
    }

    _selectBetHistoryGame(event, gameChannel) {
        event.stopPropagation();
        this.props.store.dispatch(selectBetHistoryGame(gameChannel));
    }

    _generateHistoryBetsUI() {
        let betsToDraw;
        let betsUI = '';

        if (this.state.selectedBetHistoryTab === ACTIVE_BETS_TAB && this.state.placedBets && this.state.placedBets.length) {
            betsToDraw = this.state.placedBets;
        } else if (this.state.selectedBetHistoryTab === SETTLED_BETS_TAB && this.state.settledBets && this.state.settledBets.length) {
            betsToDraw = this.state.settledBets;
        }

        if (betsToDraw && betsToDraw.length) {
            betsUI = betsToDraw.map((bet, index) => bet.Bets.filter((bt) => bt.Channel === this.state.selectedBetHistoryGame && ((this.state.selectedBetHistoryTab === SETTLED_BETS_TAB && this.state.filterWinsBetHistory && bt.Prize) || !this.state.filterWinsBetHistory || this.state.selectedBetHistoryTab === ACTIVE_BETS_TAB))).filter((bet) => bet.length > 0);
            betsUI = betsUI.map((bet, index) => bet.map((selection, sIndex) => this._generateHistoryRowUI(selection, this.state.selectedBetHistoryTab === SETTLED_BETS_TAB, index, sIndex)));
        }
        return betsUI;
    }

    _generateHistoryRowUI(bet, isSettledBet, betIndex, selectionIndex) {
        let marketDetails = this._generateMarketDetails(bet.Channel, bet.EventType, bet.Market.Code, bet.Market.Num);
        let columnCount = 2;
        let assets = '';
        let prize = '';

        if (marketDetails.assets !== '') {
            columnCount++;
            assets = (<div className={style.assets}>
                <div className={style.innerAssetsContent}>{marketDetails.assets}</div>
            </div>)
        }

        if (isSettledBet && bet.State === SETTLED) {
            columnCount++;
            prize = (<div className={style.prize}>
                {
                    `${bet.Prize === 0
                        ? getText('NO_WIN', this.props.store)
                        : getFormattedCurrency(this.props.store, (bet.Prize / BASE_VALUE).toFixed(2))}`
                }
            </div>);
        } else if (isSettledBet && bet.State === VOIDED) {
            columnCount++;
            prize = (<div className={style.prize}>
                {getText('VOIDED', this.props.store)}
            </div>);
        }

        return (<div className={betIndex % 2 === 0
            ? style.betHistoryRowEven
            : style.betHistoryRowOdd} id={`${betIndex}_${bet.Market.Num}`} key={`${betIndex}_${selectionIndex}`}>
            <div className={`${style.dateLocation} ${columnCount === 2
                ? style.centered
                : ''}`}>{`${formatTimeToHHMM(bet.EventTime)} ${bet.Title}`}</div>
            <div
                className={style.stake}>{`${getFormattedCurrency(this.props.store, (bet.Stake / BASE_VALUE).toFixed(2))} ${marketDetails.name}`}</div>
            {assets}
            {prize}
        </div>);
    }

    _generateMarketDetails(gameChannel, eventType, marketCode, marketNum) {
        let module = getModuleFromEventType(eventType);
        let marketName = '';
        let assetsUI = '';

        switch (module) {
            case RACING_MODULE:
                marketName = getText(getRacingMarketNameByCode(marketCode), this.props.store);
                if (marketNum) {
                    marketNum = marketNum.split('-');
                    if (marketNum.length) {
                        assetsUI = marketNum.map((mktNum, index) => {
                            return (<div key={index} id={'simple_bet_racer_silk_' + mktNum}
                                         className={style.marketRacerIconContainer}>
                                {
                                    hasEventTypeRacerNumberUI(eventType)
                                        ? (<div id={'slider_racer_number_' + mktNum}
                                                className={style.racerNumber}>{mktNum}</div>)
                                        : ''
                                }
                                <img
                                    src={`${ASSETS_URL}${VIRTUALS.find((game) => game.channel === gameChannel).URL.BMS_ASSETS}/silks/silk${mktNum}.png`}
                                    className={style.marketRacerIcon} key={index} alt={`icon${mktNum}`}/>
                            </div>);
                        });
                    }
                }

                break;
            case FOOTBALL_MODULE:
                marketName = getText(getFootballMarketNameByCode(marketCode), this.props.store);
                //TODO: what assets do we use for football history ????
                break;
            case BASKETBALL_MODULE:
                marketName = getText(getBasketballMarketNameByCode(marketCode), this.props.store);
                break;
            case AMERICAN_FOOTBALL_MODULE:
                marketName = getText(getAFMarketNameByCode(marketCode), this.props.store);
                break;
            default:
                break;
        }

        return {name: marketName, assets: assetsUI}
    }

    _generateFilterWinsUI() {
        let filterWinsUI = '';
        if (this.state.selectedBetHistoryTab === SETTLED_BETS_TAB) {
            filterWinsUI = (<div className={style.filterWins}>
                <div className={style.filterWinsText}>
                    {getText('ONLY_SHOW_WINS', this.props.store)}
                </div>
                <CheckCircle id={'filterWins'} style={style.filterWinsCheck} isChecked={this.state.filterWinsBetHistory}
                             isEnabled={true} callback={() => this.props.store.dispatch(toggleBetHistoryFilterWins())}/>
            </div>);
        }
        return filterWinsUI;
    }

    _generateGameButtonsUI() {
        return VIRTUALS.map((game, index) => <div id={'game_' + game.channel} key={index}
                                                  className={`${style.gameButton} ${game.channel === this.state.selectedBetHistoryGame
                                                      ? style.selected
                                                      : ''}`}
                                                  onClick={(event) => this._selectBetHistoryGame(event, game.channel)}>
            <div className={style.gameButtonText}>
                {getText(game.name, this.props.store)}
            </div>
            {this._generateBetsCounterUI(this.state.selectedBetHistoryTab === ACTIVE_BETS_TAB, index)}
        </div>);
    }

    _generateBetsCounterUI(isPlacedBetsElseSettled, gameIndex) {
        let counterUI;
        let counterId = (
            isPlacedBetsElseSettled
                ? 'active'
                : 'settled') + 'BetsCounter';
        let store = this.props.store;
        let storeData = store.getState();
        if (isLocalStorageAvailable) {
            let localBets = sessionStorage.getItem('UNREAD_BETS');
            if (localBets) {
                localBets = JSON.parse(localBets);
                let betsList = isPlacedBetsElseSettled
                    ? localBets.placedBets
                    : localBets.settledBets;
                betsList = betsList.filter((bet) => !bet.isRead);
                let games = storeData.vpp.games;
                if (games && games.length && betsList && betsList.length) {
                    let count = 0;
                    if (gameIndex !== undefined) {
                        let gameChannel = storeData.vpp.games[gameIndex].channel;
                        let gameBets = betsList.filter((bet) => bet.Bets.find((b) => b.Channel === gameChannel));
                        count = gameBets.length;
                        counterId = counterId + '_game_' + gameChannel;
                    } else {
                        count = betsList.length;
                    }

                    if (count) {
                        counterUI = (
                            <Counter count={count} wrapperStyle={style.counterWrapperStyle} htmlId={counterId}/>);
                    }
                }
            }
        }
        return counterUI;
    }

    render() {
        let store = this.props.store;

        let scrollLeft = this.state.hasScrollLeft
            ? <div className={style.leftArrow} id={'gameScrollLeft'} onClick={(event) => this._scrollGamesLeft(event)}>
                <img className={style.leftArrowIcon} src={`${ASSETS_URL}back.svg`} alt='previous'/></div>
            : '';
        let scrollRight = this.state.hasScrollRight
            ?
            <div className={style.rightArrow} id={'gameScrollRight'} onClick={(event) => this._scrollGamesRight(event)}>
                <img className={style.rightArrowIcon} src={`${ASSETS_URL}next.svg`} alt='next'/></div>
            : '';

        let filterWinsUI = this._generateFilterWinsUI();

        let betHistoryContainerStyle;
        if (this.state.isDesktopMode) {
            if (this.state.isVideoVisible) {
                betHistoryContainerStyle = style.betHistoryContainer;
            } else {
                betHistoryContainerStyle = style.betHistoryContainerCenter;
            }
        } else {
            betHistoryContainerStyle = style.betHistoryContainerMobile;
        }

        return (<div className={style.betHistoryBackground} onClick={(event) => this._closeBetHistory(event)}>
            <div className={betHistoryContainerStyle} onClick={(event) => event.stopPropagation()}>
                <div className={style.topContainer}>
                    <div className={`${style.activeBetsTab} ${this.state.selectedBetHistoryTab === ACTIVE_BETS_TAB
                        ? style.selected
                        : ''}`} id={'active_bets_tab'}
                         onClick={(event) => this._selectBetHistoryTab(event, ACTIVE_BETS_TAB)}>{getText('ACTIVE_BETS', store)}
                        {this._generateBetsCounterUI(true)}
                    </div>
                    <div className={`${style.settledBetsTab} ${this.state.selectedBetHistoryTab === SETTLED_BETS_TAB
                        ? style.selected
                        : ''}`} id={'settled_bets_tab'}
                         onClick={(event) => this._selectBetHistoryTab(event, SETTLED_BETS_TAB)}>{getText('SETTLED_BETS', store)}
                        {this._generateBetsCounterUI(false)}
                    </div>
                    <div id='betHistoryCloseBtn' onClick={(event) => this._closeBetHistory(event)}>
                        <img src={`${ASSETS_URL}close.svg`} className={style.closeButton} alt={'close'}/>
                    </div>
                </div>
                <div id={'bets_container'} className={style.content}
                     onClick={(event) => event.stopPropagation()}>{this._generateHistoryBetsUI()}</div>
                <div className={style.bottomContainer}>
                    {filterWinsUI}
                    <div className={style.buttonsContainer}>
                        <div id='betHistoryGames' className={`${style.gameButtons} ${style.scroll}`}>
                            {this._generateGameButtonsUI()}
                        </div>
                        {scrollLeft}
                        {scrollRight}
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(BetHistory);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/containers/betHistory.js